import Link from 'next/link';
import React from 'react';
import { cn } from '@/lib/utils';

export default function NavbarLink({ href, className, children, variant = 'default', ...props }) {
    const variants = {
        default: 'font-montserrat uppercase text-[12px] tracking-[0.05em] font-medium text-[#2C3E50] xl:py-2 transition-colors hover:text-main-color',
        dropdown: 'font-montserrat transition-colors hover:text-main-color normal-case',
    };

    return (
        <Link prefetch={false} {...props} href={href} className={cn(variants[variant], className)} aria-current="page">
            {children}
        </Link>
    );
}
